import { PropsWithChildren } from "react";
import {classNames, textOr} from "utils/helpers";
import "./nav-rounded-container.less";

interface Props {
  className?: string
  invisible?: boolean
  visible?: boolean
  invisibleClass?: string
}

export default function RoundedContainer(props: PropsWithChildren<Props>) {
  const invisibleClass = textOr(props.invisibleClass, "invisible")
  let isInvisible = false
  
  if (!!props.invisible) {
    isInvisible = true
  }
  
  if (typeof props.visible === "boolean") {
    isInvisible = !props.visible
  }
  
  const cssClasses: any = {}
  cssClasses[invisibleClass] = isInvisible
  
  return <div className={classNames("nav-rounded-container", props.className, cssClasses)}>
    {props.children}
  </div>
}